<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 编辑模板 -->
		<div class="title">
			<div id="notice">
				<h5>培训学习结果&nbsp;&nbsp;说明:</h5><br>
				<span class="red">1、</span><br>
				<span>2、双击显示学习详情。</span><br>
				<span>3、查询关键字:姓名、标题</span><br>
				<!-- <span>查询:标题</span><br> -->
			</div>
		</div>
		<div class="content_edit">
			<pre-button @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>

		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<!-- {{handleImportView(item)}} -->
				<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
				</component>
			</div>
		</div>

		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr :class="[isTwo=='1'?TwoNone:'']">
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
					<th class="short0 cen">编辑</th>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr v-bind:id="'m_' + user.item[1].val" :class="[isTwo=='1'?TwoNone:'']"
					@click="sel_row(user.item,'edit')" @dblclick="sel_row(user.item,'show')">
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<div v-if="d.key=='img_url'">
							<el-image style="width: 20px; height: 20px" :src="check_url(d.val)"
								:preview-src-list="[check_url(d.val)]">
							</el-image>
						</div>
						<div v-else-if="d.key=='f_web_url'">
							<a :href="d.val" target="_blank">外链</a>
						</div>
						<div v-else>{{d.val}}</div>
					</td>
					<td class="short0 cen">
						<button @click="sel_row(user.item,'show')">编辑</button>
						<button @click="fun_del(user.item,'del')">删除</button>
					</td>
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">




			</template>
		</pre-table>

		<!-- 弹出向导层 start-->
		<pretan ref="mypop">
			<template slot="tancontent">
				<!-- <h3 class="cen">{{title}}</h3> -->
				<!-- 操作按钮生成 -->
				<div class="content_edit">
					<pre-btn-tan @button-event="select_method" :pre_control="control" />
					<div class="content_btn">
						<div class="content_btn_item">
							<button @click="newPrint()">打印</button>
						</div>
					</div>
				</div>
				<div style="max-width: 600px;" >

					<div class="tab-detail">
						<h5 class="cen pretop">培训内容:</h5>
					</div>
					<div class="tab-main">
						<div class=" tab-row">
							<div class="item">
								<label>培训标题:</label>
								<span style="font-size: 16px;">{{list_main.page_title}}</span>
							</div>
						</div>
					</div>

					<div class="tab-detail">
						<h5 class="cen pretop">培训结果:</h5>
					</div>

					<div class="tab-main">
						<div class=" tab-row">

							<div class=" item-left">
								<div class="item">
									<label>培训人:</label><span>{{list_main.u_name}}</span>
								</div>
								<div class="item">
									<label>开始时间:</label><span>{{list_main.s_date}}</span>
								</div>
								<div class="item">
									<label>结束时间:</label><span>{{list_main.e_date}}</span>
								</div>
								<div class="item">
									<label>培训地点:</label><span>{{list_main.location}}</span>
								</div>
							</div>
							<div class=" item-right">
								<!-- <label>拍照:</label> -->
								<img :src="list_main.img_url" width="256px" height="auto" />


							</div>
						</div>

					</div>

					<div class="tab-detail">
						<h5 class="cen pretop">评语:</h5>
					</div>
					<div class="tab-main">
						<div class=" tab-row">
							<div class="item">
								<!-- <label>评语:</label> -->
								<textarea class="tab-txtlong" v-model="list_main.note"></textarea>
							</div>
						</div>
					</div>


				</div>
			</template>
		</pretan>

		<!-- 弹出向导层 end-->
		<div v-show="false">
			<div style="max-width: 600px;" id="page_px">
			
				<div class="tab-detail">
					<h5 class="cen pretop">培训内容:</h5>
				</div>
				<div class="tab-main">
					<div class=" tab-row">
						<div class="item">
							<label>培训标题:</label>
							<span style="font-size: 16px;">{{list_main.page_title}}</span>
						</div>
					</div>
					<div class=" tab-row">
						<div class="item">
							<label>培训分类:</label>
							<span style="font-size: 16px;">{{list_main.page_class}}</span>
						</div>
					</div>
					<div class=" tab-row">
						<div class="item">
							<label>培训介绍:</label>
							<div class="div-area" v-html="list_main.page_detail"></div>
							<!-- <textarea  class="div-area" disabled="true" v-model="list_main.page_detail"></textarea> -->
							<!-- <el-input
							  type="textarea"
							  class="div-area"
							  autosize
							  placeholder="请输入内容"
							  disabled=true
							  v-model="list_main.page_detail">
							</el-input> -->
						</div>
					</div>
					<div class=" tab-row">
						<div class="item">
							<label>培训说明:</label>
							<span style="font-size: 16px;">{{list_main.up_note}}</span>
						</div>
					</div>
				</div>
			
				<div class="tab-detail">
					<h5 class="cen pretop">培训结果:</h5>
				</div>
			
				<div class="tab-main">
					<div class=" tab-row">
			
						<div class=" item-left">
							<div class="item">
								<label>培训人:</label><span>{{list_main.u_name}}</span>
							</div>
							<div class="item">
								<label>开始时间:</label><span>{{list_main.s_date}}</span>
							</div>
							<div class="item">
								<label>结束时间:</label><span>{{list_main.e_date}}</span>
							</div>
							<div class="item">
								<label>打卡地点:</label><span>{{list_main.location}}</span>
							</div>
						</div>
						<div class=" item-right">
							<!-- <label>拍照:</label> -->
							<img :src="list_main.img_url" width="256px" height="auto" />
						</div>
					</div>
			
				</div>
			
				<div class="tab-detail">
					<h5 class="cen pretop">评语:</h5>
				</div>
				<div class="tab-main">
					<div class=" tab-row">
						<div class="item">							
							<div class="tab-txtlong">{{list_main.note}}</div>
						</div>
					</div>
				</div>
			
			
			</div>
		</div>

		<!-- 文件预览部分 -->
		<!-- 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="savefile" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="savefile" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>


	</div>
</template>

<script>
	/*
Select_PageLength  返回字符串  比较麻烦的返回结果用这个
Sel_page_and_length 一般用这个
*/
	import api from '@/utils/type.js';
	import {
		Select_PageLength,
		Method_Common,
		Method_EasySelect,
		Sel_page_and_length
	} from '@/utils/loadhttpdata.js';

	import {
		ReplaceAll
	} from '@/utils/method.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		SetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';


	export default {
		components: {
			"pre-button": () => import("../per_mode/pre_btn_control.vue"),
			"pre-btn-tan": () => import("../per_mode/pre_btn_tan.vue"),
			"pre-table": () => import("../auto/auto_view_table.vue"),
			'per-exceldown': () => import("../per_old/pre_excel_down.vue"),
			'per-excelup': () => import("../per_old/pre_excel_up_new.vue")
		},
		data() {
			return {
				element_loading: false,
				detail_data: [],

				max_row: 10,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				edit_flag: '', //add 2022-02-15 编辑类型标识
				check_key: '', //add 2022-02-15 结构匹配标识
				row_id: '',
				sys_date: '',
				list_upfileall: [],

				pop_show: false,
				screenWidth: '',
				screenHeight: '',

				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',
				kw9: '',

				show_detail: false,
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据

				f_name: "",

				//文件
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "",
				file_type: '',
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',


				list_dep: [],
				list_user: [],

				// 定义默认样式
				isTwo: '0',
				isTwoDetail: '0',
				TwoNone: 'last-two-none',

				list_main: {},
				list_detail: [],

				pre_list_data: [{
					"id": "0",
					"val": "待打款"
				}, {
					"id": "1",
					"val": "已打款"
				}],


				sel_radio: '0',
				pay_date: '',
				pay_note: '',

				bank: {},

				pre_data: {},



			};
		},
		created: function() {
			//在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，属性和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，$el 属性目前不可见。
			// console.log(this.text + ' 创建啦'); //发起ajax请求
			this.fun_init();
		},
		methods: {
			fun_init: function() {
				this.pre_data = {};

				this.$post(
					api.http_method, Method_EasySelect('_auto_build', 'auto_build', 'pageclick')
				).then(res => {
					res = JSON.parse(res);

					console.log(res.data.data);
					if (res.data.status == 1) {
						// this.list_class = [];
						// this.list_class = res.data.data;
						let t = JSON.stringify(res.data.data[0]);
						// console.log(t);
						this.pre_data = JSON.parse(t);
						this.load_data();
						console.log(this.pre_data);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			fun_option: function(e) {
				console.log('radio=' + e);
				this.sel_index = e;
			},
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: async function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;

						if (d.key == 'd_name') {
							for (let j = 0; j < this.parm_sel.length; j++) {
								if (this.parm_sel[j].key == 'u_name') {
									let res = await this.loadClass('_base_user_by_d', d.val);
									// console.log(res.data);
									this.parm_sel[j].list = [];
									this.parm_sel[j].list = res.data;
								}
							}
						}

						break;
					}
				}
				// console.log('更新后', this.parm_sel)


			},
			refresh_view_edit: async function(d, type) {
				// console.log(d);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;

							if (d.key == 'd_name') {
								for (let j = 0; j < this.parm.length; j++) {
									if (this.parm[j].key == 'u_name') {
										let res = await this.loadClass('_base_user_by_d', d.val);
										this.parm[j].list = [];
										this.parm[j].list = res.data;
									}
								}
							}

							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}
					}
				}

				if (type == 'save') {
					this.fun_upd('_add');
				}
			},
			refresh_view_edit_d: function(d, type) {
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == d.key) {
						if (this.d_parm[i].type == 'select' || this.d_parm[i].type == 'radio') {
							this.d_parm[i].val = d.val;
							this.d_parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.d_parm[i].val = d.val;
							break;
						}
						break;
					}
				}
				if (type == 'save') {
					this.fun_upd('_add');
				}
			},
			check_is_pdf: function(res_url) {
				let is_pdf = false;
				if (/\.(pdf)$/.test(res_url.toLowerCase())) {
					is_pdf = true;
				}
				return is_pdf;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: async function() {
				// console.log(r);
				// 清理缓存
				this.max_row = [];
				for (let i = 1; i < 10; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				// 清理缓存
				this.row_id = '';
				this.sel_action = '';
				this.upd_action = '';
				this.edit_flag = '';
				this.check_key = '';


				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_size = '0';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
						this.parm[j].sel_val = {};
					} else {
						this.parm[j].val = '';
					}
				}

				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}

				let r = {};
				r = this.pre_data;
				// console.log(r);

				this.title = r.title;
				this.control = r.control;
				this.pass_step = r.step; //判断是否有业务流程
				this.isFileMain = r.isFileMain; //附件保存在主单据 | 还是明细
				// console.log('pass_step=' + this.pass_step);

				this.sel_action = r.sel_action;
				this.upd_action = r.upd_action;
				this.edit_flag = r.upd_action.substring(0, 5);
				this.check_key = r.check_key;
				// console.log('编辑标识=' + this.edit_flag);

				this.file_action = r.file_action;
				this.p1 = r.p1;
				this.p2 = r.p2;
				this.p3 = r.p3;

				this.parm_sel = r.parm_sel;
				this.parm = r.parm;
				this.parm_th = r.parm_th;
				console.log(this.parm_sel);
				console.log(this.parm);

				this.detail_part = r.detail_part;

				if (this.detail_part == '1') {
					this.d_sel_action = r.d_sel_action;
					this.d_upd_action = r.d_upd_action;
					this.d_parm = r.d_parm;
					this.d_name = r.d_name;
					this.d_detail = [];

					if (r.d_btn_more == '1') {
						this.d_btn_more = true;
					}

					if (r.d_btn_del == '0') {
						this.d_btn_del = false;
					}
				}

				if (typeof(r.isTwo) != "undefined" && r.isTwo != '') {
					this.isTwo = r.isTwo;
				}

				if (typeof(r.isTwoDetail) != "undefined" && r.isTwoDetail != '') {
					this.isTwoDetail = r.isTwoDetail;
				}

				this.load_db_data();
			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			select_method: function(type) {
				console.log('操作=' + type);

				switch (type) {
					case 'new':
						this.new_blank();
						break;
					case 'clear':
						this.data_clear();
						break;
					case 'add':
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.fun_upd('_del');
						break;
					case 'sel':
						this.load_db_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_fileall();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				this.sys_date = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}

				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';
				this.kw9 = '';
				this.kw10 = '';

				this.d_detail = [];
				console.log('33333333');
				// console.log('===END============')
			},
			load_db_data: function() {
				console.log('全条件查询====');
				// console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Sel_page_and_length(that.sel_action, that.nowpage, that.page_length, that
						.kw1,
						that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, '', r);
				}, 200);
			},
			refresh_data: function(type, page, pagelength, backdata) {
				console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载
				if (type == 'PAGE_LENGTH_CHANGE') {
					this.nowpage = page;
					this.page_length = pagelength;
					this.load_db_data();
					return;
				}

				let back = null;
				if (type == 'UPDATE_OK' && typeof(backdata) != "undefined" && backdata != '') {
					// 更新编辑信息
					this.nowpage = page;
					this.load_db_data();

					back = JSON.parse(backdata);
					console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					this.sheet_flag = back.msg;
					// 同步关键参数便于后续修改
					this.sys_date = back.sys_date;
					this.sheet_no = back.sheet_no;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.parm[i].val = this.sheet_no;
							break;
						}
					}

					console.log('sheet_flag==' + this.sheet_flag + ' close=' + this.sheet_flag.indexOf('删除成功'))
					if (this.sheet_flag.indexOf('提交成功') >= 0) {
						this.show_btn = false;
					} else {
						this.show_btn = true;
					}

					if (this.sheet_flag.indexOf('删除成功') >= 0) {
						this.closeshow();
						return;
					}

					if (this.show_detail) {
						this.fun_d_load();
					}

				}

				if (Number(this.row_id) > 0) {
					// 刷新住单据信息
					this.element_loading = true;
					let r = (Math.random() + '').substring(0, 8);
					this.$post(
						api.http_method, Sel_page_and_length(this.sel_action, 1, 1, 'ID' + this.row_id, '', '', '',
							'', '', '',
							'', '', '', '', '', r)
					).then(res => {
						res = JSON.parse(res);
						console.log(res);
						this.element_loading = false;
						if (Number.parseInt(res.data.status) == 1) {
							let bd = [];
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// //console.log('key=' + j);       //输出key
									// //console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								bd.push(arr);
							}

							this.list_main = t[0];
							console.log('返回结果', this.list_main)

							if (typeof(this.d_sel_action) != 'undefined' && this.d_sel_action != '') {
								this.fun_d_load();
							}


						} else {
							this.$message({
								message: '编辑数据更新失败! \r\n ' + res.data.msg,
								type: 'success'
							});
						}

					});
				}
				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新


			},
			sel_row: function(item, type) {
				console.log('选择主单据', item);
				this.list_main = {};

				// console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
							//	根据需要设置
						case 'name':
							this.title = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						case 'pay_flag':
							console.log('pay_flag=' + item[i].val);
							if (item[i].val == '待打款') {
								this.sel_radio = '0';
							} else {
								this.sel_radio = '1';
							}
							this.sheet_flag = item[i].val;

							console.log('sel_radio=' + this.sel_radio);
							break;
						case 'p_date':
							this.pay_date = item[i].val;
							break;
						case 'p_note':
							this.pay_note = item[i].val;
							break;
						default:
							break;
					}

					let str = '';
					str = String(item[i].val);
					if (item[i].key == 'page_detail') {

						console.log(str);
						str = str.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' '); //转换格式
						// let arr = str.split('\r\n');
						// let arr = str.split('\t');
						// console.log(arr);
						// let new_str = '';
						// for (let i = 0; i < arr.length; i++) {
						// 	new_str = new_str + arr[i] + "<br/>";
						// }
						this.list_main[item[i].key] = str;
					} else {
						this.list_main[item[i].key] = str;
					}



				}

				// console.log('编辑:' , this.list_main);



				if (typeof(this.file_name) == 'undefined' || this.file_name == '') {
					this.file_show = false;
				} else {
					this.file_show = true;
				}



				console.log('主单', this.list_main);

				// console.log(this.parm);
				switch (type) {
					case 'edit': // 切换背景色
						this.$refs.file_table.setCurrentRowJsonOld('m_', item[1].val);
						break;
					case 'show': // 打开编辑页面
						this.$refs.mypop.showpop();


						break;
					case 'del': // 执行删除
						this.fun_upd('_del');
						break;
					default:
						break;
				}






			},
			fun_d_load: function() {
				this.list_detail = [];

				this.element_loading = true;
				this.$post(
					api.http_method,
					Sel_page_and_length(this.d_sel_action, 1, 999, this.sheet_no)
				).then(res => {
					this.element_loading = false;

					res = JSON.parse(res);
					// console.log('明细返回', res);
					if (res.length > 0) {
						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.list_detail.push(t[i]);
						}
						// console.log(this.list_detail);
					} else {
						this.$message({
							message: "没有查询到明细",
							type: 'success'
						});
					}
				});

			},
			new_blank: async function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;

				await this.data_clear();


				this.$refs.mypop.showpop();

			},
			closeshow: function() {
				console.log('关闭');
				this.$refs.mypop.closeshow();
			},
			fun_del: function(d) {
				this.sel_row(d, 'del');
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd' || type == '_del') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				// 删除附件
				if (type == '_del') {
					let up_file = '';
					let res = await this.sel_file();
					console.log(res)
					if (res.status == 1) {
						up_file = res.parm.f_src;
					}
					console.log('已上传文件路径=' + up_file);

					// 删除判断
					if (up_file != '') {
						await this.del_file(up_file);
					}
				}

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].w == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				let d = [];
				d.push(this.list_main.note);
				
				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_Common(this.upd_action + type, this.row_id, this.sys_date, d, r);


			},
			/* 删除 */
			sel_file: function() {

				let d = [];
				d.push('');
				d.push(this.row_id)
				var postdata = "";
				postdata = Method_Common('_lookpage_src', this.row_id, '', d)

				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(postdata).then(res => {
						res = JSON.parse(res);
						// console.log('查询文件', res);
						resolve(res.data);
					})

				});
			},
			del_file: function(up_file) {
				let userno = GetStorage('user_no');

				var postdata = "";
				postdata =
					'{"action":"' + 'file_del_upfile_sjdk' + '","user_no":"' +
					userno +
					'","upfile_path":"' +
					base_encode(up_file) +
					'","sheet_no":"' +
					'' +
					'","rowid":"' +
					this.row_id +
					'","sys_date":"' +
					'' +
					'"}';

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(postdata).then(res => {
						res = JSON.parse(res);
						console.log('删除文件', res);
						resolve(res.data);
					})

				});
			},
			load_upAllFile: function(p1, p2) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					// exp_getfilesrc_item_base 查询所有文件路径
					that.$post(
						api.http_method, Sel_page_and_length('exp_getfilesrc_item_base', 1, 100, p1, p2)
					).then(res => {

						res = JSON.parse(res);
						// console.log(res);
						resolve(res[0])
					});

				});
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					// console.log(temp_innerHtml)
					// 只替换了一个
					// temp_innerHtml = temp_innerHtml.replace(new RegExp('^', 'g'), "<br>");
					// temp_innerHtml = temp_innerHtml.replace(/\r\n/g,"<br>");
					// temp_innerHtml = temp_innerHtml.replace(/\n/g,"<br>");
					let arr = temp_innerHtml.split('\r\n');
					let new_str = '';
					for (let i = 0; i < arr.length; i++) {
						new_str = new_str + arr[i] + "<br/>";
					}

					document.getElementById("pre_msg_data").innerHTML = new_str;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			newPrint: function() {
				let that = this;
				setTimeout(function() {
					let temp_html = '';
					temp_html = document.getElementById('page_px').innerHTML;

					let newUrl = that.$router.resolve({
						path: "/modeprint",
				  query: {
							upd_action: 'print_mode'
						}
					});

					SetShort('HTML', '');
				 SetShort('HTML', encodeURI(temp_html));

					window.open(newUrl.href, "_blank");
				}, 1000)
			},
			//打印
			webPrint: function(objId) {
				var printContent = document.getElementById(objId).innerHTML; //获得需要打印内容的HTML代码
				this.PageSetup_Null(); //清空页眉页脚
				let printWindow = window.open('', '_blank',
					'width=100%,height=auto,location=0,menubar=0,status=0,toolbar=0,scrollbars=1');
				printWindow.document.write(
					'<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml"><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><meta http-equiv="Expires" content="0"><meta http-equiv="Pragma" content="no-cache"><meta http-equiv="Cache-control" content="no-cache"><meta http-equiv="Cache" content="no-cache"><link type="text/css" rel="stylesheet" href="/css/my_mode.css" /><title></title></head><body>'
				); //这里是向新建的窗口写入HTML的head信息，可引入自己的js和css，以供打印时样式与网页中显示的一致
				printWindow.document.write('<div style="width:100%; height:100%; overflow:hidden;">' + printContent +
					"</div>"); //这里向新建的窗体中写入BODY的内容，注意，外边加的额外DIV是有必要的，它里面CSS可以控制打印时不会出现空白页
				printWindow.document.write("</body></html>"); //这里向新建的窗体写入HTML的结束标记
				printWindow.focus(); //当前新建的窗口获得焦点
				printWindow.document.close(); //关闭新建窗口的文档输出流，这个是必须的，否则下面的打印语句无效
				printWindow.print(); //打印当前新建窗口中的内容
				printWindow.close(); //关闭新建的窗口
				this.PageSetup_Default(); //把页眉页脚恢复为默认
			},
			PageSetup_Null: function() {
				//设置网页打印的页眉页脚为空
				var HKEY_Root, HKEY_Path, HKEY_Key;
				HKEY_Root = "HKEY_CURRENT_USER";
				HKEY_Path = "\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
				try {
					var Wsh = new ActiveXObject("WScript.Shell");
					HKEY_Key = "header";
					Wsh.RegWrite(HKEY_Root + HKEY_Path + HKEY_Key, "");
					HKEY_Key = "footer";
					Wsh.RegWrite(HKEY_Root + HKEY_Path + HKEY_Key, "");
				} catch (e) {}
			},

			PageSetup_Default: function() {
				//设置网页打印的页眉页脚为默认值
				var HKEY_Root, HKEY_Path, HKEY_Key;
				HKEY_Root = "HKEY_CURRENT_USER";
				HKEY_Path = "\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
				try {
					var Wsh = new ActiveXObject("WScript.Shell");
					HKEY_Key = "header";
					Wsh.RegWrite(HKEY_Root + HKEY_Path + HKEY_Key, "&w&b页码，&p/&P");
					HKEY_Key = "footer";
					Wsh.RegWrite(HKEY_Root + HKEY_Path + HKEY_Key, "&u&b&d");
				} catch (e) {}
			},
			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						message: '操作不正确1,请选择要上传附件的具体分类信息!',
						type: 'warning'
					});
					return;
				}
				console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确2,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				this.file_size = 0;
				this.file_type = '';

				this.file_url = '';
				this.file_src = '';

				let fileobj = document.getElementById('savefile');
				fileobj.click();
			},
			fun_look_file: async function(item) {
				console.log('点击预览附件');
				if (typeof(item) !== 'undefined' && item != '') {
					await this.sel_row(item);
				}

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					var pdfview = document.getElementById('loodlink');
					pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					pdfview.click();

				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('savefile');
				// console.log('点击选择结果');
				console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 5000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];

					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					this.file_size = size;

					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;

					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过5M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					this.file_show = true;

				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_fileall: async function() {
				this.list_upfileall = [];
				this.list_upfileall = await this.load_upAllFile(this.row_id);
				console.log(this.list_upfileall)
				if (typeof(this.list_upfileall) !== 'undefined') {
					for (let i = 0; i < this.list_upfileall.length; i++) {
						if (this.list_upfileall[i].f_src != '') {
							await this.fun_del_file(this.list_upfileall[i]);
						}
					}
					this.load_db_data();
				}
			},
			fun_del_file: function(item) {
				console.log(item);
				var postdata = "";
				postdata =
					'{"action":"' + 'file_del_upfile' + this.file_action + '","user_no":"' +
					item.sign_no +
					'","upfile_path":"' +
					base_encode(item.file_src) +
					'","sheet_no":"' +
					'' +
					'","rowid":"' +
					item.id +
					'","sys_date":"' +
					item.sys_date +
					'"}';

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						// console.log(res);
						res = JSON.parse(res);
						resolve(res.data)
					});

				});



			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				// console.log('文件大小=' + this.file_data.length)
				if (this.file_data.length > 0) {
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// console.log('上传长度=' + temp_data.size);
					// console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);

				postdata =
					'{"user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(this.file_name) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';
				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				console.log('p3=' + this.p3);
				this.element_loading = true;

				var postdata = "";
				postdata =
					'{"action":"data_save' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","f_name":"' +
					DeleteSpecialWord(this.file_name) +
					'","f_type":"' +
					this.file_type +
					'","f_size":"' +
					this.file_size +
					'","f_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","mode_type":"' +
					this.mode_type +
					'","mode_name":"' +
					this.mode_name +
					'"}';

				// console.log(postdata);
				postdata =
					'{"method":"File_NewSavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.load_db_data();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	/* 设置 倒数 第二、第三列 隐藏 */
	.last-two-none>td:nth-last-child(4),
	.last-two-none>td:nth-last-child(3) {
		display: none;
	}

	.last-two-none>td:nth-last-child(3) {
		display: none;
	}

	.tab-main {
		display: inline-flex;
		background-color: #ebebebd9;
		justify-items: center;
		align-items: center;
		align-content: space-around;
		justify-content: space-around;
		padding: 10px;
		border-radius: 5px;
		flex-direction: column;
		width: 100%;
		max-width: 600px;
	}

	.tab-row {
		display: inline-flex;
		width: 100%;
		margin-bottom: 6px;

	}

	.tab-row .item {
		display: inline-flex;
		margin: 2px;
		width: 100%;
	}

	.tab-row .item label {
		min-width: 80px;
		text-align: right;
		justify-content: flex-end;
		align-items: flex-start;
	}

	.tab-row .item span {
		display: inline-flex;
		font-size: 16px;
		font-weight: bold;
		min-width: 168px;
		align-items: center;
	}

	.tab-row .item .div-area {
		display: inline-flex;
		font-size: 16px;
		font-weight: bold;
		text-align: left;
		width: calc(100% - 80px);
	}

	.tab-menu {
		display: inline-flex;
		align-items: center;
		width: 100%;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		/* margin-top: 20px; */
	}

	.tab-menu .left,
	.tab-menu .right {
		display: inline-flex;
	}

	.tab-menu .right button {
		font-size: 20px;
	}

	.tab-detail {

		display: inline-flex;
		width: 100%;
		margin-top: 6px;
		max-width: 600px;
	}

	.tab-txtlong {
		display: inline-block;
		min-width: 600px;
		width: 100%;
		overflow: auto;
		min-height: 100px;
		font-size: 18px;
		line-height: 24px;
		border: 0px;
		font-weight: 500;
		font-family: cursive;
		    text-align: left;
	}

	.item-left {
		display: inline-flex;
		width: 320px;
		flex-direction: column;
	}

	.item-right {
		display: inline-flex;
		width: 256px;
		flex-direction: row;
		align-items: flex-start;
	}

	.item-right img {
		display: inline-flex;
		width: 256px;
		height: auto;

	}
</style>
